import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { RegionsEffects } from './effects/regions.effects';
import { NotificationsEffects } from './effects/notifications.effects';
import { SettingsEffects } from './effects/settings.effects';
import { InstallationDashboardsEffects } from './effects/installation-dashboards.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('coreState', reducers),
    EffectsModule.forFeature([
      RegionsEffects,
      NotificationsEffects,
      SettingsEffects,
      InstallationDashboardsEffects
    ]),
  ]
})
export class CoreStoreModule {}
